import PatientContactInfo from './PatientContactInfo';

export default PatientContactInfo;
